import {Component, computed, inject, input, linkedSignal, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxLoadIndicatorModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from '../../shared/shared.module';
import {MenuCompositionDTO} from '../../core/dtos/menucomposition-dto';
import {MenusCompositionService} from '../../core/services/gestionmenus/menus-composition.service';
import {AllergenesService} from '../../core/services/entities/allergenes-service.service';
import {AppellationsService} from '../../core/services/entities/appellations.service';
import {UtilsService} from '../../core/utils/utils.service';
import {ToastService} from '../../core/services/technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";
import {ProduitAllergeneDTO} from "../../core/dtos/produit-allergene-dto";
import {ProduitAppellationDTO} from "../../core/dtos/produit-appellation-dto";

@Component({
  selector: 'yo-edit-allergenes-appellations-menucompo',
  templateUrl: './edit-allergenes-appellations-menucompo.component.html',
  styleUrls: ['./edit-allergenes-appellations-menucompo.component.scss'],
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxLoadIndicatorModule, SharedModule]
})

export class EditAllergenesAppellationsMenucompoComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;
  readonly #menuCompoSvc = inject(MenusCompositionService);
  readonly allergeneSvc = inject(AllergenesService);
  readonly appellationSvc = inject(AppellationsService);
  readonly #utils = inject(UtilsService);
  readonly #toastSvc = inject(ToastService);
  title = input.required<string>();

  readonly menuComposition = input<MenuCompositionDTO>();
  readonly saved = output<MenuCompositionDTO>();

  readonly displayDialog = linkedSignal(() => !!this.menuComposition());


  isLoading = computed(() =>
    this.appellationSvc.appellationResource.isLoading ||
    this.allergeneSvc.allergeneResource.isLoading()
  );

  selectedAllergeneIdList = linkedSignal(() => this.menuComposition()?.produitAllergeneDTOList.map(item => item.allergeneId) ?? []);
  selectedAppellationIdList = linkedSignal(() => this.menuComposition()?.produitAppellationDTOList.filter(item => item.actif)
                                                                                                                         .map(item => item.appellationId) ?? []);
  onAllergeneChange = (ids: number[]) => this.selectedAllergeneIdList.set(ids ?? []);

  onAppellationChange = (ids: number[]) => this.selectedAppellationIdList.set(ids);

  save = () => {
    const mc = this.menuComposition();
    this.#menuCompoSvc.saveMenuCompositionAppellationsAllergenes(mc.id, this.selectedAppellationIdList(), this.selectedAllergeneIdList()).subscribe((resp: any) => {
      if (!this.#utils.isResponseSupplierError(resp)) {
        this.#toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
          `Les allergènes et appellations de "${mc.produitDeclinaisonLibelle}" ont été enregistrés`);

        const allergeneList = this.allergeneSvc.allergeneResource.value();
        const appellationList = this.appellationSvc.appellationResource.value();
        const selectedAllergeneIds = this.selectedAllergeneIdList();
        const selectedAppellationIds = this.selectedAppellationIdList();

        const updatedMc: MenuCompositionDTO = {
          ...mc,
          appellationOrAllergeneModified: true,
          produitAllergeneDTOList: allergeneList
            .filter(a => selectedAllergeneIds.includes(a.id))
            .map(a => { const dto = new ProduitAllergeneDTO(); dto.allergeneId = a.id; dto.allergeneLibelle = a.libelle; dto.actif = true; return dto; }),
          produitAppellationDTOList: appellationList
            .filter(a => selectedAppellationIds.includes(a.id))
            .map(a => { const dto = new ProduitAppellationDTO(); dto.appellationId = a.id; dto.appellationLibelle = a.libelle; dto.actif = true; return dto; })
        };

        this.saved.emit(updatedMc);
        this.displayDialog.set(false);
      }
    });
  };

}
